import React, { useRef, useEffect, useCallback, useState} from 'react';
import {getLeafString} from 'effects/midi/tidal/parser.js';
import TidalPart from './TidalPart.js';
import {expandCycle} from 'effects/midi/tidal/tidal.js';
import Colors from 'components/Colors.js';
import {connect} from 'react-redux';
const colors = new Colors();

window.hrotate = 4;

const TidalVisualizer = ({effect, cycle, currentCycles}) => { 
    let parts = useRef({});
    let lastParts = useRef([]);

    useEffect(() => {
        if (!currentCycles) {
            return ;
        }
        let _parts = parts.current;
        lastParts.current.forEach(
            x => {
                if (x.current && x.current.style) {
                    x.current.style.borderBottom = 'none';
                }
            });

        lastParts.current = [];
        for (let cycle in currentCycles) {
            if (_parts[cycle]) {
                _parts[cycle]
                    .forEach(
                        part => {
                            if (part.current && part.current.style) {
                                part.current.style.borderBottom = '1px solid white';
                            }
                        });
                lastParts.current = [... lastParts.current, ... _parts[cycle]];
            }
        }
    }, [currentCycles]);
    return (

        <div className="tidal-visualizer">
          <TidalPart
            parts={parts}
            effect={effect}
            cycle={cycle}
            total={100}
          />
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      cycle: props.effect.cycle,
      currentCycles: props.effect.currentCycles
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TidalVisualizer);
